export type {
    MotionTransitionConstantType,
    MotionDurationConstantType,
    MotionTimingConstantType,
    MotionTransition,
    MotionIntentType,
    MotionEasingType,
    MotionSpringType,
    MotionTiming,
    MotionIntent,
    MotionSpring,
    MotionType
} from "./timing";

export type {
    MotionCrossfadeStyleConstantType,
    MotionAppearStyleConstantType,
    MotionSlideStyleConstantType,
    MotionCrossfadeStyleType,
    MotionProgressType,
    MotionStyleType
} from "./style";

export {
    getCrossfadeStyle,
    getAppearStyle,
    getSlideStyle
} from "./style";

export {
    MOTION_BADGE_HIDDEN_SCALE,
    MOTION_ICON_APPEAR_SCALE,
    MOTION_ICON_APPEAR_BLUR,
    MOTION_ICON_POP_SCALE,
    MOTION_SURFACE_SCALE,
    getMotionTransition,
    MOTION_CSS_EASINGS,
    MOTION_PRESS_SCALE,
    getMotionDuration,
    getMotionTiming,
    MOTION_EASINGS,
    MOTION_INTENTS,
    MOTION_SPRINGS
} from "./timing";

export {
    default as suppressWebTransitions
} from "./suppressWebTransitions";

export {
    default as useAnimatedState
} from "./useAnimatedState";

export {
    default as useReducedMotion
} from "./useReducedMotion";

export {
    default as useMotionTiming
} from "./useMotionTiming";

export {
    default as usePressScale
} from "./usePressScale";

export {
    default as usePresence
} from "./usePresence";
